"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalTableState = void 0;
/**
 * Because the ag-grid is not a true React component, a lot of the state related to operations
 * and interactions with ag-grid should be and are treated in 'typical' fashion, outside of the
 * usual React state.
 */
var InternalTableState = /** @class */ (function () {
    function InternalTableState() {
        var _this = this;
        this.firstDataRendered = false;
        this.lastScrollPosition = {
            top: 0,
            left: 0,
        };
        this.isMetaOrCtrlKeyPressed = false;
        this.isAltKeyPressed = false;
        this.lastResizedWidth = 0;
        this.lastResizedHeight = 0;
        this.destroy = function () {
            var _a;
            _this.abandonInitialization();
            _this.stopWatching();
            (_a = _this.table) === null || _a === void 0 ? void 0 : _a.destroy();
        };
        /**
         * Abandon current table initialization (if any). This will not cancel any in-flight requests but will
         * make sure that when they complete they are noop - dead work.
         */
        this.abandonInitialization = function () {
            if (_this.initializer) {
                _this.initializer.abandon();
            }
            _this.initializer = undefined;
        };
        this.stopWatching = function () {
            if (_this.watchingIntervalId) {
                clearInterval(_this.watchingIntervalId);
                _this.watchingIntervalId = undefined;
            }
        };
        this.startWatching = function (handler, timeout) {
            if (_this.watchingIntervalId) {
                return;
            }
            _this.watchingIntervalId = window.setInterval(handler, timeout);
        };
        /**
         * Checks if the last size on record for this table is same as the provided sizes. If it is, don't
         * do anything and return false. If the sizes differ, they will be updated and true is returned.
         *
         * @param width - width to test & update if needed
         * @param height - height to test & update if needed
         */
        this.checkAndUpdateLastSize = function (width, height) {
            if (_this.lastResizedWidth !== width || _this.lastResizedHeight !== height) {
                _this.lastResizedWidth = width;
                _this.lastResizedHeight = height;
                return true;
            }
            return false;
        };
    }
    return InternalTableState;
}());
exports.InternalTableState = InternalTableState;
//# sourceMappingURL=tableState.js.map